export default "__VITE_ASSET__e6f947ef__"